interface RenderIfProps {
  children: any | null;
  isTrue: boolean;
}

export const RenderIf = ({ children, isTrue }: RenderIfProps) =>
  isTrue ? children : null;

export const RenderElse = ({ children, isTrue }: RenderIfProps) =>
  !isTrue ? children : null;